export default __webpack_public_path__ + "static/media/download (3).7ce2b6ee.jpg";